module.exports = __webpack_public_path__ + "assets/img/flechacategoriasWhite.439202cb.svg";